import { FC } from 'react';
import { CheckboxGroup, CheckboxGroupProps } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

type FormCheckboxGroupFieldProps = CheckboxGroupProps & Omit<ControllerProps, 'transform'>;

export const FormCheckboxGroupField: FC<FormCheckboxGroupFieldProps> = ({
    onChange,
    options,
    name,
    rules,
    shouldUnregister,
    defaultValue,
    ...other
}) => {
    const { value, error, handleChange } = useControllerWithEventHandler({
        defaultValue,
        name,
        rules,
        shouldUnregister,
        onChange,
    });

    return <CheckboxGroup options={options} values={value} error={error} onChange={handleChange} {...other} />;
};
